import RoomFilterIcon from './RoomFilterIcon';
import { getStyles } from './RoomFilterWellItem.styles';
import type RoomFilterWellItemViewState from './RoomFilterWellItemViewState';
import { classNamesFunction } from '@fluentui/utilities';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import ReadWriteCommonWellItem from 'owa-readwrite-common-well/lib/components/ReadWriteCommonWellItem';
import * as React from 'react';
import type {
    ReadWriteCommonWellItemProps,
    ReadWriteCommonWellItemStyleProps,
    ReadWriteCommonWellItemStyles,
} from 'owa-readwrite-common-well/lib/components/ReadWriteCommonWellItem.types';
import { roomPanelFilterWellRemoveButton } from './RoomFilterWell.locstring.json';
import loc from 'owa-localize';

const getClassNames = classNamesFunction<
    ReadWriteCommonWellItemStyleProps,
    ReadWriteCommonWellItemStyles
>();

const styles = require('./RoomFilterWell.scss');

export interface RoomFilterWellItemProps
    extends ReadWriteCommonWellItemProps<RoomFilterWellItemViewState> {
    colorScheme: ColorScheme;
}

export default class RoomFilterWellItem extends ReadWriteCommonWellItem<
    RoomFilterWellItemViewState,
    RoomFilterWellItemProps
> {
    protected renderWellItem = () => {
        return (
            <div
                key={`roomfilterwell_item_${this.props.index}`}
                ref={ref => (this.focusWrapper = ref)}
                className={styles.focusableItem}
                data-is-focusable={true}
                data-is-sub-focuszone={true}
                onKeyDown={this.onKeyDown}
                data-selection-index={this.props.index}
                aria-label={this.props.viewState.displayText}
                role="listitem">
                {this.getRenderResult()}
            </div>
        );
    };

    protected getCustomizedClassName = (): {
        [key in keyof ReadWriteCommonWellItemStyles]: string;
    } => {
        let { theme, isSelected, maxItemWidth } = this.props;

        return getClassNames(getStyles, {
            isSmallSize: true,
            isRegularSize: false,
            isSelected: isSelected,
            isValid: true,
            isExpanding: false,
            isExpandable: false,
            theme: theme,
            maxItemWidth: maxItemWidth,
        });
    };

    protected getPersonaControl = (): JSX.Element => {
        let { viewState, colorScheme } = this.props;

        return (
            <div className={this.classNames.personaInfoWrapper}>
                <RoomFilterIcon
                    colorScheme={colorScheme}
                    small={true}
                    roomFilterType={viewState.filterType}
                />
                <span className={this.classNames.wellItemText}>{viewState.displayText}</span>
            </div>
        );
    };

    protected getLeadingElement = (): JSX.Element => {
        return null;
    };

    protected getDisplayTextFromItem = (item: RoomFilterWellItemViewState): string => {
        return null;
    };

    protected getCanDragItem = (item: RoomFilterWellItemViewState): boolean => {
        return false;
    };

    protected getContextMenu = (): JSX.Element => {
        return null;
    };

    protected getStringForRemoveButton = () => {
        return loc(roomPanelFilterWellRemoveButton);
    };
}
